import { FC } from "react";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SkeletonCard } from "./styled";

const Skeleton: FC = () => {
  return (
    <ModuleSkeleton>
      {[...Array(5)].map((_, index) => (
        <SkeletonCard key={`skeleton-card-${index}`} />
      ))}
    </ModuleSkeleton>
  );
};

export default Skeleton;
